<template>
	<div class="global-loader" v-if="isLoading">
		<Loader
			class="global-loader__loader"
			show
			backdrop
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/Loader';

export default {
	components: {
		Loader,
	},
	computed: {
		...mapGetters('loader', [
			'isLoading',
		]),
	}
}
</script>

<style>

</style>